'use client';

import {RefSectionEntitiesFragment, RefSectionFieldsFragment} from '@common/hygraph-schema';
import {FAQSection, SideBySideSection} from './';
import {ContentSection} from './Content.section';
import {ExtraProps} from '@/types/hygraph.types';

type SectionType<Section extends {__typename: any}> = {
	[S in Section as S['__typename']]: any;
};

type RefSectionsEntitiesSection = Exclude<RefSectionEntitiesFragment['section'], null | undefined>;

export type SectionTypename = keyof SectionType<RefSectionsEntitiesSection>;

export const getSections = (
	sections?: RefSectionFieldsFragment[] | null,
	extraProps?: ExtraProps
): (React.JSX.Element | null | undefined)[] => {
	if (!sections || !sections.length) return [];
	return sections.map((refSection, i) => {
		const section = refSection.section;
		if (!section || !section.__typename) return;

		switch (section.__typename) {
			case 'SectionSideBySide':
				return <SideBySideSection key={`ref-section-side-by-side-${i}`} {...section} />;

			case 'SectionContent':
				return (
					<ContentSection
						key={`ref-section-content-${i}`}
						{...section}
						extraProps={extraProps}
					/>
				);

			case 'SectionFaq':
				return <FAQSection key={`ref-section-faq-${i}`} {...section} />;

			default:
				return null;
		}
	});
};
